import { render } from "./WithdrawalPasswordSetReset.vue?vue&type=template&id=786fd638"
import script from "./WithdrawalPasswordSetReset.vue?vue&type=script&lang=js"
export * from "./WithdrawalPasswordSetReset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__